import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "table-config-container"
};
const _hoisted_2 = {
  class: "config-toolbar"
};
const _hoisted_3 = {
  class: "config-column-list"
};
import { ref, watch } from 'vue';
import { XDialog } from '@/components';
import { saveColumnsConfig, readColumnsConfig } from './configStore';
export default {
  __name: 'tableColumnConfig',
  props: {
    title: {
      type: String,
      default: '表格配置'
    },
    columns: {
      type: Array,
      required: true
    },
    open: {
      type: Boolean,
      default: false
    },
    configKey: {
      type: String,
      default: ''
    }
  },
  emits: ['update:open', 'apply-config'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const tableColumns = ref([]);
    const openRef = ref(props.open);
    const loadColumnConfig = defineColumns => {
      if (!props.configKey) {
        tableColumns.value = defineColumns || [];
        return;
      }
      tableColumns.value = readColumnsConfig(props.configKey, defineColumns || []);
    };
    watch(() => props.columns, val => {
      loadColumnConfig(val);
    }, {
      immediate: true,
      deep: true
    });
    watch(() => props.open, val => {
      openRef.value = val;
    }, {
      immediate: true
    });
    const handleDialogClose = () => {
      emit('update:open', false);
    };
    const handleConfigApply = () => {
      const rows = tableColumns.value.slice() || [];
      if (props.configKey) {
        // 只保存标题，可见性属性
        saveColumnsConfig(props.configKey, rows.map(item => {
          const {
            title,
            visible,
            dataIndex,
            key,
            configDisabled
          } = item;
          return {
            title,
            visible,
            dataIndex,
            key,
            configDisabled
          };
        }));
      }
      emit('apply-config', rows);
      openRef.value = false;
    };
    const handleCheckColumnsAll = checked => {
      const rows = tableColumns.value.slice() || [];
      for (const column of rows) {
        if (column.configDisabled) {
          continue;
        }
        column.visible = checked;
      }
      tableColumns.value = rows;
    };
    const handleUncheckColumnsAll = () => {
      const rows = tableColumns.value.slice() || [];
      for (const column of rows) {
        if (column.configDisabled) {
          continue;
        }
        column.visible = !column.visible;
      }
      tableColumns.value = rows;
    };
    const handleColumnVisibleChange = (item, index) => {
      const rows = tableColumns.value.slice() || [];
      if (rows[index].configDisabled) return;
      rows[index].visible = !rows[index].visible;
      tableColumns.value = rows;
    };
    const handleColumnTitleChange = (index, e) => {
      const rows = tableColumns.value.slice() || [];
      if (rows[index].configDisabled) return;
      rows[index].title = e.target.value;
      tableColumns.value = rows;
    };
    return (_ctx, _cache) => {
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_space_compact = _resolveComponent("a-space-compact");
      const _component_a_list_item = _resolveComponent("a-list-item");
      const _component_a_list = _resolveComponent("a-list");
      return _openBlock(), _createBlock(_unref(XDialog), {
        open: openRef.value,
        "onUpdate:open": _cache[0] || (_cache[0] = $event => openRef.value = $event),
        "ok-text": "应用",
        "cancel-text": "取消",
        title: __props.title,
        onAfterClose: handleDialogClose,
        onOk: handleConfigApply
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_checkbox, {
          "onUpdate:checked": handleCheckColumnsAll
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("全选/取消选择", -1)]))]),
          _: 1
        }), _createVNode(_component_a_button, {
          size: "small",
          type: "dashed",
          onClick: handleUncheckColumnsAll
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("反选", -1)]))]),
          _: 1
        })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_a_list, {
          "item-layout": "vertical",
          "data-source": tableColumns.value,
          bordered: false
        }, {
          renderItem: _withCtx(({
            item,
            index
          }) => [(_openBlock(), _createBlock(_component_a_list_item, {
            key: index
          }, {
            default: _withCtx(() => [!item.configDisabled ? (_openBlock(), _createBlock(_component_a_space_compact, {
              key: 0,
              block: true,
              direction: "horizontal"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                checked: item.visible,
                onChange: () => handleColumnVisibleChange(item, index)
              }, null, 8, ["checked", "onChange"]), _createVNode(_component_a_input, {
                value: item.title,
                bordered: false,
                onChange: e => handleColumnTitleChange(index, e)
              }, null, 8, ["value", "onChange"])]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)]),
            _: 2
          }, 1024))]),
          _: 1
        }, 8, ["data-source"])])])]),
        _: 1
      }, 8, ["open", "title"]);
    };
  }
};